import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Container, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import Section from '../../common/Section/Section'
 
const Wrap = styled.div`
  color: white;
  .list-item {    
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 10px;
    .gatsby-image-wrapper {
      margin-right: .75rem;
    }
    p {
      margin: 8px 0 0 0;
    }
  }
`
 
const EnergyEfficientSection = ({ data }) => {
  // console.log("energy data: ", data)
  const { richText1, richText2 } = data ? data : { data: null }

  const check = useStaticQuery(graphql`
    query {
      check: contentfulAsset(title: {eq: "Check"}) {
        title
        fixed(width: 28, height: 30) {
          ...GatsbyContentfulFixed
        }
      }
    }
  `).check

  const options = {
    renderNode: {
      [BLOCKS.LIST_ITEM]: (node, children) => (
        <div className="list-item">
          <div className="check-wrap">
            <Img fixed={check.fixed} alt="check-mark" />
          </div>          
          <p>{node.content[0].content[0].value}</p>
        </div>
      )
    }
  }
  return (
    <Wrap>
      <Section data={data} bgFade>
        <Container fluid>
          <Row>
            <Col lg={9} md={12}>
              {richText1 && documentToReactComponents(richText1.json)}
            </Col>
          </Row>
          <Row>
            <Col lg={7} md={12}>
              {richText2 && documentToReactComponents(richText2.json, options)}
            </Col>
          </Row>
        </Container>                
      </Section>
    </Wrap>
  )
}
 
export default EnergyEfficientSection